import { pvsystActions } from './actions';
import { pvsystMutations } from './mutations';
import { pvsystGetters } from './getters';

const state = {
  inputData: {},
  globalIncline: 0,
  energieCompteurAC : 0
};
const actions = { ...pvsystActions };
const mutations = { ...pvsystMutations };
const getters = { ...pvsystGetters };


// eslint-disable-next-line import/prefer-default-export
export const pvsystStore = {
  state, actions, mutations, getters,
};
